import React from "react";

const ProductInfo = ({product}) => {
  return (
    <div className={'max-w-4xl'}>
      <h4 className={'text-gray-900 font-semibold text-2xl text-center mt-10'}>{product.name}</h4>
      <div dangerouslySetInnerHTML={{__html: product.information}}/>
    </div>
  );
}

export default ProductInfo;
